export const SCROLL_DELAY_MS = 100;
//https://github.com/usablica/intro.js/blob/master/intro.js#L1386
function elementInViewport(y, height = 0) {
    const winHeight = window.innerHeight;
    const elementTop = y;
    const elementBottom = y + height;
    const viewportTop = window.pageYOffset;
    const viewportBottom = viewportTop + winHeight;
    return (elementBottom > viewportTop &&
        elementBottom < viewportBottom &&
        elementTop < viewportBottom &&
        elementTop > viewportTop);
}
export function scrollTo(y, height) {
    const winHeight = window.innerHeight;
    if (!elementInViewport(y, height)) {
        const top = y - window.pageYOffset;
        const distanceToScroll = top - (winHeight / 2 - height / 2);
        if (height > winHeight)
            return;
        if (top < 0) {
            window.scrollBy(0, distanceToScroll - 30); //  from intro.js: 30px padding from edge to look nice
        }
        else {
            window.scrollBy(0, distanceToScroll + 30); //  from intro.js: 30px padding from edge to look nice
        }
    }
}
const easings = {
    linear(t) {
        return t;
    },
    easeInQuad(t) {
        return t * t;
    },
    easeOutQuad(t) {
        return t * (2 - t);
    },
    easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
        return t * t * t;
    },
    easeOutCubic(t) {
        return --t * t * t + 1;
    },
    easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
        return t * t * t * t;
    },
    easeOutQuart(t) {
        return 1 - --t * t * t * t;
    },
    easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint(t) {
        return t * t * t * t * t;
    },
    easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
    },
    easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
};
/**
 * Attempts to find a matching element (from `id` or `name` attribute) to scroll to based of window.location.hash
 * Returns the anchor or null
 */
export function getScrollIntoViewAnchor(doc) {
    const _hashValue = doc.location.hash.replace('#', '');
    const hash = _hashValue.length ? _hashValue : '';
    const idAnchor = !!hash
        ? doc.querySelector(`[id="${hash}"]`)
        : null;
    const nameAnchor = !idAnchor && !!hash ? doc.querySelector(`[name="${hash}"]`) : null;
    let anchor = null;
    if (idAnchor) {
        anchor = idAnchor;
    }
    else if (nameAnchor) {
        anchor = nameAnchor;
    }
    return anchor;
}
export function scrollIt(destination, duration = 200, easing = 'linear', callback) {
    const start = window.pageYOffset;
    const startTime = performance.now();
    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight;
    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset);
    function scroll() {
        const now = performance.now();
        const time = Math.min(1, (now - startTime) / duration);
        const timeFunction = easings[easing](time);
        window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));
        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }
        requestAnimationFrame(scroll);
    }
    scroll();
}
//# sourceMappingURL=scroll.js.map